














import { Component, Prop, Vue } from 'vue-property-decorator'

import AppSectionTimedItem from '@/components/AppSectionTimedItem.vue'

@Component({
  components: {
    AppSectionTimedItem
  }
})
export default class extends Vue {
  @Prop(Array) readonly items!: { timeSaleInfo: { startedAt: number; expiredAt: number } }[]

  now = Math.floor(Date.now() / 1000)
  intervalId!: any

  get validItems () {
    return this.items.filter(item => item.timeSaleInfo.startedAt <= this.now && this.now <= item.timeSaleInfo.expiredAt)
  }

  mounted () {
    this.intervalId = setInterval(() => {
      console.log('AppSectionTimedSale setInterval')
      this.now = Math.floor(Date.now() / 1000)
    }, 1000)
  }

  beforeDestroy () {
    clearInterval(this.intervalId)
  }
}
